import { render, staticRenderFns } from "./AppointmentModification.vue?vue&type=template&id=90cb6df2"
import script from "./AppointmentModification.vue?vue&type=script&lang=ts"
export * from "./AppointmentModification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports